export const REGISTER_STEP_DATA = [
  { tittle: "personal", detail: "Add personal details" },
  { tittle: "Address", detail: "Add additional info" },
  { tittle: "Message", detail: "Add message(optional)" },
  { tittle: "Done", detail: "Complete.. !" },
];

export const SAMPLE_DATA = [
  {
    text: "Prior to publishing content on social media",
  },
];
